import { render, staticRenderFns } from "./IconMenuAlt1Solid.vue?vue&type=template&id=1a2d4ef2"
import script from "./IconMenuAlt1Solid.vue?vue&type=script&lang=js"
export * from "./IconMenuAlt1Solid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports